import {
  Button,
  Card,
  Col,
  message,
  Row,
  Table,
  Input,
  Modal,
  Select,
} from "antd";
import { Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { strings } from "res";
import { deleteMenu } from "redux/features/menu";

import { useMenu } from "hooks/useMenu";
import { LocalizedModal } from "components/shared-components/LocalizedModal";

import { formatRupiah } from "utils/index";

export const MENU = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { Title, Paragraph } = Typography;

  //   Hooks
  const [modal, contextHolder] = Modal.useModal();

  const { data, getData, isLoading, menuTypes, filters, setFilters, metaData } =
    useMenu();

  const tableColumns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Menu",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Foto",
      dataIndex: "image_url",
      key: "image_url",
      render: (_, record) => (
        <div
          style={{
            margin: "auto",
            display: "flex",
          }}
        >
          <img
            src={record.image_url}
            style={{ width: 60, height: "auto" }}
          ></img>
        </div>
      ),
    },
    {
      title: "Deskripsi",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Harga Normal",
      dataIndex: "normal_price",
      key: "normal_price",
      render: (text) => formatRupiah(text),
    },
    {
      title: "Harga Diskon",
      dataIndex: "discount_price",
      key: "discount_price",
      render: (text) => formatRupiah(text),
    },
    {
      title: "Presentase Diskon",
      dataIndex: "discount_percentage",
      key: "discount_percentage",
    },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating",
    },
    {
      title: "Tipe Menu",
      dataIndex: "menu_type",
      key: "menu_type",
      render: (menu_type) => menu_type?.name || "-",
    },

    {
      title: () => <div className="text-center">Detail</div>,
      key: "detail",
      render: (_, record) => (
        <div className="text-center">
          <Button
            type="primary"
            style={{ textAlign: "center" }}
            onClick={() => {
              history.push({
                pathname: `${strings.navigation.path.detail_menu}`,
                state: record,
              });
            }}
          >
            Detail
          </Button>
        </div>
      ),
    },
    {
      title: () => <div className="text-center">Action</div>,
      key: "status",
      render: (_, record) => (
        <div className="text-center">
          <Button
            type="danger"
            style={{
              textAlign: "center",
              color: "white",
            }}
            onClick={() => {
              confirm(record.id);
            }}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  const confirm = (id) => {
    modal.confirm({
      title: "Are you sure?",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure wanna delete this?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        await dispatch(deleteMenu(id));
        getData(filters);
      },
      onCancel: () => {},
    });
  };

  const handleCategorySelect = (val) => {
    setFilters({ ...filters, type: val });
  };

  const handleSearchByTitle = (event) => {
    const val = event.target.value.trim();
    setFilters({
      ...filters,
      name: val || undefined,
    });
  };

  const handleTableChange = (pagination, _filter, sorter) => {
    const { field, order } = sorter;
    const sortableFields = ["date_published", "created_at"];

    const newFilters = {
      ...filters,
      page: pagination.current,
    };

    if (sortableFields.includes(field) && order) {
      newFilters.sort = order === "ascend" ? field : `-${field}`;
    }

    setFilters(newFilters);
  };

  return (
    <>
      <LocalizedModal></LocalizedModal>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Title level={2}>Daftar Menu</Title>
          <Paragraph>Tampilkan semua menu berdasarkan filter data.</Paragraph>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <Row gutter={[16, 2]}>
              <Col xs={24} sm={24} md={12} lg={12} span={6}>
                <Input
                  placeholder="Cari Berdasarkan Nama"
                  onChange={handleSearchByTitle}
                  className="mb-4 mr-4"
                  allowClear
                  style={{ width: "100%" }}
                />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} span={6}>
                <Select
                  placeholder="Filter Berdasarkan Kategori"
                  onSelect={handleCategorySelect}
                  options={menuTypes}
                  className="mb-4 mr-4"
                  allowClear
                  onClear={handleCategorySelect}
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>
            <Table
              className="no-border-last"
              style={{
                textAlign: "center",
                margin: "auto",
              }}
              scroll={{ x: "100%" }} // Menambahkan scrolling horizontal
              columns={tableColumns}
              dataSource={data}
              rowKey="id"
              loading={isLoading}
              pagination={{
                defaultPageSize: metaData.limit,
                defaultCurrent: metaData.page,
                total: metaData.total_data,
              }}
              onChange={handleTableChange}
            />
          </Card>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Button
            type="primary"
            style={{ border: "0px" }}
            htmlType="submit"
            onClick={() => {
              history.push({
                pathname: `${strings.navigation.path.detail_menu}`,
              });
            }}
            block
          >
            Tambah Menu
          </Button>
        </Col>
      </Row>
      {contextHolder}
    </>
  );
};

export default withRouter(MENU);
